import store from "@/state/store";
import axios from "axios";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    //component: () => import("../views/dashboard/ecommerce/index.vue"),
    component: () => import("../views/mirai/dashboard/"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await axios.post("/ad/logout", {}, {
            withCredentials: true,
          });

          // Armazena o email antes de limpar
          const username = localStorage.getItem("username");

          localStorage.clear();
          sessionStorage.clear();

          // Restaura o email
          if (username) localStorage.setItem("username", username);

          next({ path: "/login" });
        } catch (e) {
          console.error("Erro no logout:", e);
          next({ path: "/login" });
        }
      },
    },
    component: () => import("../views/auth/logout/basic"),
  }
];
